module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/bottom-panel.0255dced.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/components/LeaderboardTable/images/bottom-panel.png
// module id = 3090
// module chunks = 11